<template>
  <div class="relative">
    <label
      class="absolute absolute-y-center transition-300 ml-4 lg:ml-8 font-medium capitalize"
      :class="[!hasContent ? 'text-grey-500' : 'text-taupe-500 text-sm', labelClass]"
      :style="{ transform: `translateY(${hasContent ? 'calc(-50% - 14px)' : '-50%' })` }"
    >
      {{ label }}
    </label>
    <input
      type="text"
      class="w-full border border-grey-200 pb-2 pt-6 px-4 transition-300 text-grey-500 font-medium text-lg truncate focus:outline-none lg:pb-4 lg:pt-8 lg:px-8 lg:pr-12"
      :class="[{ 'lg:border-grey-400': focused, 'cursor-pointer': !focused && selectedAirport }, inputClass]"
      v-bind="$attrs"
      v-on="listeners"
      :value="displayedValue"
      autocomplete="off"
    >
    <div
      class="absolute absolute-y-center right-0 mr-4 lg:mr-8 inline-flex"
      :class="{ 'pointer-events-none': !focused && selectedAirport && ! (selectedAirport.is_open && (selectedAirport.jetfly_pc12_operability !== 'unoperable' || selectedAirport.jetfly_pc24_operability !== 'unoperable' || selectedAirport.jetfly_sf50_operability !== 'unoperable')) }"
    >
      <TransitionFadeSlideUpFast>
        <button @click="$emit('clear')" v-if="value || selectedAirport" class="cursor-pointer">
          <SvgClose class="h-4 w-4 text-grey-400" />
        </button>
        <slot name="input-right" v-else-if="!!$slots['input-right']" />
      </TransitionFadeSlideUpFast>
    </div>
  </div>
</template>

<script>
import TransitionFadeSlideUpFast from '@/components/transitions/FadeSlideUpFast'
import SvgClose from '@/components/svg/Close'

export default {
  inheritAttrs: false,
  components: { TransitionFadeSlideUpFast, SvgClose },
  props: {
    label: { type: String, required: true },
    inputClass: { type: String, required: false },
    labelClass: { type: String, required: false },
    value: { type: String, default: '' },
    focused: { type: Boolean, default: false },
    selectedAirport: { type: Object, default: null },
  },
  computed: {
    listeners () {
      return {
        ...this.$listeners,
        input: (event) => this.$emit('input', event.target.value),
      }
    },
    hasContent () {
      return this.focused || this.displayedValue
    },
    displayedValue () {
      if (!this.value && !this.focused && this.selectedAirport) return this.selectedAirport.name
      else return this.value
    }
  },
  watch: {
    selectedAirport: {
      handler (val) {
        if (val) this.$emit('input', '')
      }
    }
  }
}
</script>
